import { render, staticRenderFns } from "./OrderDocumentInfoButton.vue?vue&type=template&id=96849476"
import script from "./OrderDocumentInfoButton.vue?vue&type=script&lang=js"
export * from "./OrderDocumentInfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports